import store from "@shared/modules/store"

import { WOW_MONEY_INTERVAL } from "live/constants"

/**
 * 세션에 남기는 시각. 새로고침으로 시청 시간이 초기화되지 않게 한다.
 * 값은 이미 열려 있는 탭의 세션과 어긋나지 않도록 그대로 둔다.
 */
export const SESSION_KEY = {
  /** 현재 적립 주기의 시작 시각 */
  CYCLE_STARTED_AT: "initial",
  /** 새로고침 직전 시각 */
  REFRESHED_AT: "refresh",
} as const

/**
 * 새로고침으로 되살릴 수 있는 주기 시작 시각을 세션에서 읽는다.
 *
 * 새로고침이 아니면(다른 경로로 재입장) 되살리지 않고 처음부터 다시
 * 재도록 undefined 를 돌려준다.
 *
 * 떠났다 돌아온 경우, 자리를 비운 시간(떠난 시각 ~ 지금)은 시청한 것으로
 * 치지 않도록 그만큼 주기 시작 시각을 뒤로 민다. 이러면 방송을 잠깐만
 * 보고 나갔다가 마감 직전에 돌아와도 남은 시간이 그대로 남아 있고,
 * 반대로 거의 다 채운 뒤 마감을 살짝 넘겨 재접속해도(부재 시간이 짧으므로)
 * 주기가 통째로 리셋되지 않는다.
 */
const restoreCycleStartedAt = () => {
  const refreshedAt = Number(store.session.get(SESSION_KEY.REFRESHED_AT))
  const startedAt = Number(store.session.get(SESSION_KEY.CYCLE_STARTED_AT))
  const isRefreshed =
    Number.isInteger(refreshedAt) &&
    Number.isInteger(startedAt) &&
    refreshedAt > startedAt

  if (!isRefreshed) return undefined

  const absence = Math.max(0, Date.now() - refreshedAt)

  return startedAt + absence
}

export default restoreCycleStartedAt
